import { PrintTypeInterface } from "@/model/components/PrintTypeInterface.ts";
import { ConfirmationOfTheFinishedImageInterface } from "@/model/components/ConfirmationOfTheFinishedImageInterface";
import { OrderDetailsInterface } from "@/model/components/manuscript/OrderDetailsInterface.ts";
import { PaperInterface } from "@/model/components/DrawerPaperInterface.ts";
import { AvailabilityOfOptionsInterface } from "@/model/components/AvailabilityOfOptionsInterface.ts";
import { OrderInformationInterface } from "@/model/components/OrderInformationInterface.ts";
import { ProductDeliveryAddressInterface } from "@/model/components/ProductDeliveryAddressInterface.ts";
import { ProductDeliveryMethodInterface } from "@/model/components/ProductDeliveryMethodInterface.ts";
import { PaymentMethodInterface } from "@/model/components/PaymentMethodInterface.ts";
import { QuestionsInterface } from "@/model/components/new/QuestionsInterface.ts";
import { SubmitBtnInterface } from "@/model/components/SubmitBtnInterface.ts";

export interface ManuscriptInterface {
  printType: PrintTypeInterface;
  confirmationOfTheFinishedImage: ConfirmationOfTheFinishedImageInterface;
  orderDetailsList: OrderDetailsInterface[];
  paper: PaperInterface;
  availabilityOfOptions: AvailabilityOfOptionsInterface;
  orderInformation: OrderInformationInterface;
  productDeliveryAddress: ProductDeliveryAddressInterface;
  productDeliveryMethod: ProductDeliveryMethodInterface;
  paymentMethod: PaymentMethodInterface;
  questions: QuestionsInterface;
  submitBtn: SubmitBtnInterface;
}

interface ValidationResultsInterface {
  [key: string]: boolean | boolean[];
  printType: boolean;
  confirmationOfTheFinishedImage: boolean;
  orderDetailsList: boolean[];
  paper: boolean;
  availabilityOfOptions: boolean;
  orderInformation: boolean;
  productDeliveryAddress: boolean;
  productDeliveryMethod: boolean;
  paymentMethod: boolean;
  questions: boolean;
}

export const validationResults = {
  printType: true,
  confirmationOfTheFinishedImage: true,
  orderDetailsList: [],
  paper: true,
  availabilityOfOptions: true,
  orderInformation: true,
  productDeliveryAddress: true,
  productDeliveryMethod: true,
  paymentMethod: true,
  questions: true
} as ValidationResultsInterface;
